module.exports = __webpack_public_path__ + "static/media/Hackathon2.bc0f8bd6.jpg";